/** ISO 3166-1 alpha-2 country code to flag emoji (e.g. "NO" → "🇳🇴"). */
export const countryCodeToFlag = (code: string): string => {
  if (!code || code.length !== 2) {
    return '';
  }
  return [...code.toUpperCase()].map((c) => String.fromCodePoint(0x1f1e6 - 65 + c.charCodeAt(0))).join('');
};
